import { Flags } from "@epicgames-ps/lib-pixelstreamingfrontend-ue5.5";
import { ArcwarePixelStreaming } from "../../ArcwarePixelStreaming";
import { MicIcon } from "../MicIcon";

export class MicButton {
  private button: HTMLButtonElement;
  private stream: ArcwarePixelStreaming;
  private micIcon: MicIcon;
  private tooltipText: HTMLElement;

  constructor(stream: ArcwarePixelStreaming) {
    this.stream = stream;
    this.setMicMutedByDefault();
    this.button = this.createButton();
    this.micIcon = new MicIcon();
    this.tooltipText = this.createTooltipText();
    this.button.appendChild(this.tooltipText);
    this.button.appendChild(this.micIcon.micIconMuted);
    this.button.appendChild(this.micIcon.micIconUnmuted);
    this.micIcon.micIconUnmuted.style.display = "none";
    this.button.addEventListener("click", this.toggleMic.bind(this));
  }

  private setMicMutedByDefault(): void {
    const videoElementParent = this.stream.videoElementParent;
    if (videoElementParent) {
      const videoElement = videoElementParent.querySelector("video");
      if (videoElement) {
        this.stream.toggleMic(false, true);
      }
    }
  }

  private createButton(): HTMLButtonElement {
    const button = document.createElement("button");
    button.setAttribute("id", "micBtn");
    button.setAttribute("type", "button");
    button?.classList?.add("UiTool");
    return button;
  }

  private createTooltipText(): HTMLElement {
    const tooltipText = document.createElement("span");
    tooltipText?.classList?.add("tooltiptext");
    tooltipText.innerHTML = "Mic on/off";
    return tooltipText;
  }

  private toggleMic(): void {
    const micFlag = this?.stream?.config?.isFlagEnabled(Flags.UseMic);
    this.stream.toggleMic(!micFlag, false);
    this.updateMicIcon(!micFlag);
  }

  private updateMicIcon(micActive: boolean): void {
    if (!micActive) {
      this.micIcon.micIconUnmuted.style.display = "none";
      this.micIcon.micIconMuted.style.display = "block";
    } else {
      this.micIcon.micIconMuted.style.display = "none";
      this.micIcon.micIconUnmuted.style.display = "block";
    }
  }

  public get element(): HTMLButtonElement {
    return this.button;
  }
}
